import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    const saved = localStorage.getItem('cart');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1) => {
    setItems(prev => {
      const existingIndex = prev.findIndex(item => item.id === product.id && item.item_type === product.item_type);
      if (existingIndex >= 0) {
        const newItems = [...prev];
        newItems[existingIndex].quantity += quantity;
        return newItems;
      }
      return [...prev, {
        id: product.id,
        item_type: product.item_type,
        name: product.name,
        origin: product.origin || '',
        spec: product.spec || '',
        price: product.price,
        unit: product.unit,
        image_url: product.image_url,
        quantity,
      }];
    });
  };

  const updateQuantity = (productId, itemType, quantity) => {
    if (quantity <= 0) {
      removeItem(productId, itemType);
      return;
    }
    setItems(prev => prev.map(item => 
      (item.id === productId && item.item_type === itemType) ? { ...item, quantity } : item
    ));
  };

  const removeItem = (productId, itemType) => {
    setItems(prev => prev.filter(item => !(item.id === productId && item.item_type === itemType)));
  };

  const clearCart = () => {
    setItems([]);
  };

  const totalAmount = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <CartContext.Provider value={{ 
      items, 
      addItem, 
      updateQuantity, 
      removeItem, 
      clearCart,
      totalAmount,
      totalItems
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};
